import PublicPortalApp from './PublicPortalApp.container';

export default PublicPortalApp;
